import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  isChunkError: boolean;
}

export class ChunkLoadErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, isChunkError: false };

  static getDerivedStateFromError(error: Error): State {
    const isChunkError =
      error.message.includes('Failed to fetch dynamically imported module') ||
      error.message.includes('error loading dynamically imported module') ||
      error.message.includes('Loading chunk') ||
      error.message.includes('Loading CSS chunk') ||
      error.message.includes('Unable to preload CSS for') ||
      error.name === 'ChunkLoadError';
    return { hasError: true, isChunkError };
  }

  handleRefresh = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      if (this.state.isChunkError) {
        return (
          <div className="flex h-screen flex-col items-center justify-center gap-4 p-8">
            <h2 className="text-xl font-semibold text-gray-900">Application Updated</h2>
            <p className="max-w-md text-center text-gray-600">
              A new version of the application is available. Please refresh the page to continue.
            </p>
            <button
              onClick={this.handleRefresh}
              className="mt-2 rounded-lg bg-[#1e3a5f] px-6 py-2.5 text-white hover:bg-[#162d4a]"
            >
              Refresh Page
            </button>
          </div>
        );
      }
      return (
        <div className="flex h-screen flex-col items-center justify-center gap-4 p-8">
          <h2 className="text-xl font-semibold text-red-600">Something went wrong</h2>
          <p className="max-w-md text-center text-gray-600">
            An unexpected error occurred. Please try refreshing the page.
          </p>
          <button
            onClick={this.handleRefresh}
            className="mt-2 rounded-lg bg-gray-200 px-6 py-2.5 hover:bg-gray-300"
          >
            Refresh Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
